<ng-template let-line #home>
  <span
    class="cursor-pointer flex items-center h-8"
    routerLink="/home"
    routerLinkActive="active"
  >
    Home
  </span>
</ng-template>

<ng-template let-line #reporting>
  <span
    class="cursor-pointer flex items-center h-8"
    routerLink="/reporting"
    routerLinkActive="active"
  >
    Reporting
  </span>
</ng-template>

<ng-template let-line #budget>
  <span
    class="cursor-pointer flex items-center h-8"
    routerLink="/budget"
    routerLinkActive="active"
  >
    Budget
  </span>
</ng-template>

<ng-template let-line #admin>
  <span
    class="cursor-pointer flex items-center h-8"
    routerLink="/admin/months"
    routerLinkActive="active"
  >
    Admin
  </span>
</ng-template>

<ng-template let-line #subLinkTemplate>
  <div class="sublinks-container">
    @for (link of subLinks(); track link.path) {
      <span
        class="cursor-pointer"
        [routerLink]="link.path"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ link.label }}
      </span>
    }
  </div>
</ng-template>

@if (!isAccessDenied()) {
  <stena-toolbar
    [headers]="headers()"
    [headerItemTemplates]="{ home, reporting, budget, admin }"
    [showSublinks]="subLinks().length > 0"
    [subLinkTemplate]="subLinkTemplate"
    class="toolbar"
  >
    <stena-user-menu
      (handleLogout)="onLogout()"
      (handleLoginSuccess)="onLoginSuccess($event)"
    />
  </stena-toolbar>
}

<main class="page-shell">
  <section class="content">
    <router-outlet></router-outlet>
  </section>
</main>

@if (!isAccessDenied()) {
  <stena-footer class="footer"></stena-footer>
}
